import { all } from 'redux-saga/effects'

import { tariffsSaga } from './tariffs/sagas'

export function* billingSaga() {
  yield all([tariffsSaga()])
}
